import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { TranslationFunction } from '@/src/types/translations'
import { Box } from '@mui/material'
import React, { useState } from 'react'
import LobTabs, { LobTabItem } from '@/src/components/common/ui/lobTabs'
import { AIModeToggleHome } from '../../AISearch/AIModeToggleHome'
import { AISearchBox } from '../../AISearch/homeAISearchBox'
import SearchForm from '../searchForm'
import { TabPanel } from '../tabPanel'

interface FlightSearchTabsProps {
    t: TranslationFunction<'header'>
    tabValue: number
    onTabChange: (newValue: number) => void
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
    fromParam?: any[] | null
    toParam?: any[] | null
    showVisaTab?: boolean
    showFlightsHotelsTab?: boolean
    showExperienceTab?: boolean
    showAiSearchTab?: boolean
}

type FlightSearchMode = 'search' | 'ai'

export const FlightSearchTabs: React.FC<FlightSearchTabsProps> = ({
    t,
    tabValue,
    onTabChange,
    isMobile,
    serverRecentSearches,
    hideMulticity,
    fromParam,
    toParam,
    showVisaTab = false,
    showFlightsHotelsTab = false,
    showExperienceTab = false,
    showAiSearchTab = false
}) => {
    const showThirdTab = showVisaTab || showFlightsHotelsTab
    const flightsTabIndex = 0

    const [flightMode, setFlightMode] = useState<FlightSearchMode>('search')
    const AIModeActive = showAiSearchTab && tabValue === flightsTabIndex && flightMode === 'ai'

    const tabs: LobTabItem[] = [
        { key: 'flights', label: t('flights') },
        { key: 'hotels', label: t('hotels') }
    ]
    if (showThirdTab) {
        tabs.push({ key: showVisaTab ? 'visa' : 'fph', label: showVisaTab ? t('visa') : t('fph') })
    }
    if (showExperienceTab) {
        tabs.push({ key: 'experience', label: t('experience') })
    }

    return (

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', position: 'relative', }}>
            {/* Line-of-business pills — shared with the hotels search form. */}
            <LobTabs tabs={tabs} activeIndex={tabValue} onTabChange={onTabChange} ariaLabel="flight search tabs" />

            {/* Search Form Container - Separate white box with top overlapped by tabs */}
            <Box sx={AIModeActive ? {
                width: '100%', position: 'relative',
                zIndex: 1,
                mt: '-15px',
                pt: 2,
                background: (theme) => `linear-gradient(155deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 50%, ${theme.palette.primary.main} 100%)`,
                borderRadius: 2
            } : {
                width: '100%', position: 'relative',
                zIndex: 1,
                mt: '-12px'
            }}>
                <Box
                    sx={{
                        bgcolor: 'common.white',
                        px: 3,
                        pt: 2,
                        pb: 3,
                        borderRadius: 2,
                        border: 2,
                        borderColor: 'grey.100',
                        width: '100%',
                        position: 'relative',
                        zIndex: 1,
                        mt: '-12px' // Negative margin to create 20% overlap with tabs bottom (approximately 20% of tabs container height)
                    }}
                >
                    <TabPanel value={tabValue} index={flightsTabIndex}>
                        {showAiSearchTab && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-start', pb: 2 }}>
                                <AIModeToggleHome
                                    value={flightMode}
                                    onChange={setFlightMode}
                                    deviceType="desktop"
                                />
                            </Box>
                        )}

                        {showAiSearchTab && flightMode === 'ai' ? (
                            <AISearchBox />
                        ) : (
                            <SearchForm
                                isMobile={isMobile}
                                serverRecentSearches={serverRecentSearches}
                                hideMulticity={hideMulticity}
                                fromParam={fromParam}
                                toParam={toParam}
                            />
                        )}
                    </TabPanel>
                </Box>
            </Box>
        </Box>
    )
}
